import { Component } from '@angular/core';

@Component({
  selector: 'app-section-descricao-cultura-colaborativa',
  templateUrl: './section-descricao-cultura-colaborativa.component.html',
  styleUrls: ['./section-descricao-cultura-colaborativa.component.scss'],
})
export class SectionDescricaoCulturaColaborativaComponent {}
